<div class="sidebar-wrapper d-flex flex-column h-100">
  <aside class="client-sidebar d-flex flex-column h-100 bg-white border-0 border-opacity-50 px-3 px-lg-4 py-4 mt-5">
    <div v-if="uses_case_owner_sidebar" class="sidebar-content case-owner-sidebar-layout flex-grow-1 d-flex flex-column">
      <section class="case-owner-profile-card rounded-4 border p-3">
        <div class="d-flex align-items-start gap-3">
          <div class="case-owner-avatar rounded-circle d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0">
            {{ case_owner_profile.initials }}
          </div>

          <div class="min-w-0 flex-grow-1">
            <div class="case-owner-name fw-semibold text-truncate">{{ case_owner_profile.name }}</div>
            <div class="case-owner-meta text-uppercase text-truncate">
              {{ sidebar_meta_line || 'USER - WORKSPACE' }}
            </div>
          </div>
        </div>

        <div class="case-owner-metrics row g-0 text-center">
          <div v-for="metric in case_owner_profile.metrics" :key="metric.label" class="col-4">
            <div class="case-owner-metric-value">{{ metric.value }}</div>
            <div class="case-owner-metric-label text-uppercase">{{ metric.label }}</div>
          </div>
        </div>

        <button
          type="button"
          class="case-owner-profile-link d-flex align-items-center justify-content-between text-decoration-none border-0 bg-transparent w-100 px-0 text-start"
          @click="open_case_owner_profile_modal"
        >
          <span>View profile</span>
          <i class="bi bi-chevron-right"></i>
        </button>
      </section>

      <nav class="entity-sidebar case-owner-sidebar-nav mt-4">
        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">MY WORK</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in case_owner_work_items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-nav-link"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <i :class="['bi', item.icon, 'fs-6']"></i>
                  <span>{{ item.label }}</span>
                </span>
                <span v-if="has_count(item.count)" class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>

        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">MY CASES - BY STATUS</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in case_owner_status_items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-status-link"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <span class="case-owner-status-dot rounded-circle" :class="item.status_color ? '' : item.dot_class" :style="item.dot_style"></span>
                  <span>{{ item.label }}</span>
                </span>
                <span class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>
      </nav>

      <section class="case-owner-intake-section mt-auto pt-2">
        <div class="sidebar-role-block pb-2">
          <div class="sidebar-role-meta fw-semibold">INTAKE</div>
        </div>

        <div class="case-owner-intake-card rounded-4">
          <button
            type="button"
            class="case-owner-intake-link nav-link d-flex align-items-center justify-content-between fw-semibold w-100 border-0 bg-transparent"
            @click="go_to_case_owner_intake_queue"
          >
            <span>Inbound queue</span>
            <span v-if="has_count(intake_queue_count)" class="case-owner-intake-count">{{ intake_queue_count }}</span>
          </button>
          <div class="case-owner-intake-copy text-uppercase">Auto-routed by rule engine</div>
          <button
            type="button"
            class="case-owner-intake-action border-0 bg-transparent d-inline-flex align-items-center gap-2"
            @click="go_to_case_owner_intake_queue"
          >
            <i class="bi bi-chevron-down"></i>
            <span>Load new cases</span>
          </button>
        </div>

        <button
          type="button"
          class="requestor-sidebar-new-case-button w-100 mt-3"
          @click="go_to_company_new_case"
        >
          <span class="d-flex align-items-center gap-3">
            <i class="bi bi-plus-lg"></i>
            <span>New case (manual)</span>
          </span>
        </button>
      </section>

      <div class="pt-4 mt-auto border-top">
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>

      <CaseOwnerProfileModal
        :visible="show_case_owner_profile_modal"
        :profile="case_owner_profile"
        :save-version="case_owner_profile_save_version"
        @close="close_case_owner_profile_modal"
        @save-profile="handle_case_owner_profile_save"
      />
    </div>

    <div v-else-if="uses_requestor_sidebar" class="sidebar-content flex-grow-1 d-flex flex-column">
      <nav class="entity-sidebar case-owner-sidebar-nav mt-4">
        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">MY WORK</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in requestor_work_items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-nav-link"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <i :class="['bi', item.icon, 'fs-6']"></i>
                  <span>{{ item.label }}</span>
                </span>
                <span v-if="has_count(item.count)" class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>

        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">NEW</div>
          </div>

          <button
            type="button"
            class="requestor-sidebar-new-case-button w-100"
            @click="go_to_requestor_new_case"
          >
            <span class="d-flex align-items-center gap-3">
              <i class="bi bi-plus-lg"></i>
              <span>New case</span>
            </span>
          </button>
        </section>
      </nav>

      <div class="pt-4 mt-auto border-top">
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>
    </div>

    <div v-else-if="uses_intake_officer_sidebar" class="sidebar-content case-owner-sidebar-layout flex-grow-1 d-flex flex-column">
      <nav class="entity-sidebar case-owner-sidebar-nav mt-4">
        <section class="mb-5">
          <div class="sidebar-role-block">
            <div class="sidebar-role-meta fw-semibold">INTAKE DESK</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in intake_officer_work_items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-nav-link"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <i :class="['bi', item.icon, 'fs-6']"></i>
                  <span>{{ item.label }}</span>
                </span>
                <span v-if="has_count(item.count)" class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>

        <section class="mb-4">
          <div class="sidebar-role-block">
            <div class="sidebar-role-meta fw-semibold">NEW</div>
          </div>

          <button
            type="button"
            class="requestor-sidebar-new-case-button w-100"
            @click="go_to_coordinator_new_case"
          >
            <span class="d-flex align-items-center gap-3">
              <i class="bi bi-plus-lg"></i>
              <span>Register manually</span>
            </span>
          </button>
        </section>
      </nav>

      <div class="pt-4 mt-auto border-top">
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>
    </div>

    <div v-else-if="uses_coordinator_sidebar" class="sidebar-content flex-grow-1 d-flex flex-column">
      <nav class="entity-sidebar mt-3">
        <section class="mb-4">
          <div class="sidebar-role-block">
            <div class="sidebar-role-meta fw-semibold">COORDINATOR SCOPE</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in coordinator_work_items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <i :class="['bi', item.icon, 'fs-6']"></i>
                  <span>{{ item.label }}</span>
                </span>
                <span v-if="has_count(item.count)" class="coordinator-sidebar-count">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>

        <section class="mb-4">
          <div class="sidebar-role-block">
            <div class="sidebar-role-meta fw-semibold">NEW</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li>
              <button
                type="button"
                class="nav-link d-flex align-items-center fw-semibold w-100 border-0 bg-transparent coordinator-sidebar-action"
                @click="go_to_coordinator_new_case"
              >
                <i class="bi bi-plus-lg fs-6"></i>
                <span>Register a case</span>
              </button>
            </li>
          </ul>
        </section>
      </nav>

      <div class="pt-4 mt-auto border-top">
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>
    </div>

    <div v-else class="sidebar-content flex-grow-1 d-flex flex-column justify-content-between">
      <nav class="entity-sidebar mt-3">
        <template v-for="group in sidebar_groups" :key="group.id">
          <ul class="nav flex-column gap-1">
            <div class="sidebar-role-block">
              <div class="sidebar-role-meta fw-semibold">{{ project_sidebar_meta_line || 'ADMIN - WORKSPACE' }}</div>
            </div>
            <li v-for="item in group.items" :key="item.id">
              <button
                v-if="item.external_system === 'config'"
                type="button"
                class="nav-link d-flex align-items-center fw-semibold w-100 border-0 bg-transparent"
                @click="go_to_config_system"
              >
                <i :class="['bi', item.icon, 'fs-6']"></i>
                <span>{{ item.label }}</span>
              </button>
              <router-link
                v-else
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center fw-semibold"
                active-class="active"
                @click="close_sidebar"
              >
                <i :class="['bi', item.icon, 'fs-6']"></i>
                <span>{{ item.label }}</span>
              </router-link>
            </li>
          </ul>
        </template>
      </nav>

      <div class="pt-4 mt-4 border-top">
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>
    </div>
  </aside>
  <div
    v-if="show_coordinator_register_modal"
    class="company-case-modal-backdrop d-flex align-items-center justify-content-center"
    @click.self="close_coordinator_register_modal"
  >
    <section class="company-case-modal bg-white manual-intake-modal position-relative">
      <blocking-loader-overlay
        :show="submitting_coordinator_manual_case"
        message="Registering case..."
        detail="Please wait while the case and its requestor form are being saved."
      ></blocking-loader-overlay>
      <header class="company-case-modal-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2 class="company-case-modal-title mb-2">{{ coordinator_manual_case.title }}</h2>
          <div class="company-case-modal-copy">{{ coordinator_manual_case.subtitle }}</div>
        </div>
        <button type="button" class="company-case-modal-close btn border-0 p-0" aria-label="Close modal" @click="close_coordinator_register_modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="company-case-modal-body">
        <div v-if="coordinator_manual_case_error" class="small text-danger fw-semibold mb-3" role="alert">
          {{ coordinator_manual_case_error }}
        </div>
        <p v-if="coordinator_manual_case.description" class="mb-4 company-case-modal-description">
          {{ coordinator_manual_case.description }}
        </p>
        <div class="mb-3">
          <label class="company-case-modal-label text-uppercase mb-2" for="sidebar_manual_intake_requester">Requester<span class="manual-required-marker">*</span></label>
          <input
            id="sidebar_manual_intake_requester"
            v-model.trim="coordinator_manual_case.requester"
            type="text"
            class="form-control company-case-modal-control"
            placeholder="Full name"
            :disabled="submitting_coordinator_manual_case"
          >
        </div>

        <div class="mb-3">
          <label class="company-case-modal-label text-uppercase mb-2" for="sidebar_manual_intake_contact">Contact</label>
          <input
            id="sidebar_manual_intake_contact"
            v-model.trim="coordinator_manual_case.contact"
            type="text"
            class="form-control company-case-modal-control"
            placeholder="Phone or email"
            :disabled="submitting_coordinator_manual_case"
          >
        </div>

        <div class="mb-3">
          <label class="company-case-modal-label text-uppercase mb-2" for="sidebar_manual_intake_location">Location / Address</label>
          <input
            id="sidebar_manual_intake_location"
            v-model.trim="coordinator_manual_case.location"
            type="text"
            class="form-control company-case-modal-control"
            placeholder="Address or area"
            :disabled="submitting_coordinator_manual_case"
          >
        </div>

        <div class="mb-0">
          <label class="company-case-modal-label text-uppercase mb-2" for="sidebar_manual_intake_case_type">Case type<span class="manual-required-marker">*</span></label>
          <select
            id="sidebar_manual_intake_case_type"
            v-model="coordinator_manual_case.case_type"
            class="form-select company-case-modal-control"
            :disabled="submitting_coordinator_manual_case"
          >
            <option value="" disabled>Select a case type</option>
            <option v-for="option in coordinator_case_type_options" :key="option.id" :value="option.id">{{ option.label }}</option>
          </select>
        </div>
      </div>

      <footer class="company-case-modal-footer d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-light border px-4" :disabled="submitting_coordinator_manual_case" @click="close_coordinator_register_modal">
          Need more info
        </button>
        <button
          type="button"
          class="btn btn-primary-dark px-4"
          :disabled="submitting_coordinator_manual_case || !coordinator_manual_case.case_type || !(coordinator_manual_case.description || coordinator_manual_case.requester)"
          @click="submit_coordinator_manual_case"
        >
          {{ submitting_coordinator_manual_case ? 'Registering...' : 'Register -> onto main DB' }}
        </button>
      </footer>
    </section>
  </div>
</div>
